// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2zdzE","col":"styles_col__2bWm5","fulfillmentStatus":"styles_fulfillmentStatus__1jAu8","emailCol":"styles_emailCol__2PMbq"};